export const LanguagesInLosAngeles = [
  {
    heading: "Document",
    detail:
      "If you're in need of translation services for your educational, institutional, or governmental needs, feel free to get started with us. Our document translation services are equipped with certified translations for all of your documents.",
    link: "/document-translation-services",
    secondHeading: "Translation Services",
  },
  {
    heading: "Medical",
    detail:
      "Translation and interpretation are part-and-parcel of the medical industry. Our medical interpreters and translators are equipped with the latest tools to configure the patient's needs. Make sure your medical documents, records, and academic journal are on par, too, with translation.",
    link: "/medical-translation.php",
    secondHeading: "Translation Services",
  },
  {
    heading: "Legal",
    detail:
      "Our legal experts are adept in the various fields of law. Our experience in translating law documents span affidavits, patents, contracts, and other legal documents. Make sure all your necessary interactions can be verified in a court of law, with legal translation services.",
    link: "/legal-translation.php",
    secondHeading: "Translation Services",
  },
  {
    heading: "Financial",
    detail:
      "Concerned about your financial documents needing a translation? Our financial experts are here to help. They're knowledgeable about terminologies in the field of finance, and have the past proven track record for it.",
    link: "/financial-translation.php",
    secondHeading: "Translation Services",
  },
  {
    heading: "Interpreting",
    detail:
      "Looking for interpreting services? Tomedes can scale up your business with their vast knowledge of Los Angeles interpreters. Interpreting can break communication barriers. Get in touch today.",
    link: "/interpretation-services",
    secondHeading: "Services",
  },
  {
    heading: "Technical",
    detail:
      "Tomedes' document translation services for Los Angeles are available for local businesses and businesses looking to broaden their horizons to LA. Our linguists are knowledgeable about every aspect of document translation services, from legal to individual to business needs document translation services, from legal to individual to business need need.",
    link: "/technical-translation.php",
    secondHeading: "Translation Services",
  },
];

export const TranslationInLosAngeles = [
  {
    heading: "Chinese Translation Services",
    detail:
      "The city of California estimates that 63,323 people speak Chinese (including Mandarin and Cantonese). 29,444 of this population have low English profiency. Chinese is also one of the primary languages of business. If you're looking to translate from English to Chinese and vice versa, get started a Chinese translator in Los Angeles.",
    link: "/mandarin-chinese-translation",
  },
  {
    heading: "Spanish Translation Services",
    detail:
      "A huge number of people speak Spanish in LA: 3.3 million people, in just Los Angeles county alone. How will you reach your Spanish-speaking audience in Los Angeles without Spanish translation? Don't worry. Tomedes is here. We're the preferred LA translation company in California, as evidenced by our 97% client satisfaction rate. Get in touch.",
    link: "/spanish-translation.php",
  },
];
